import { render, staticRenderFns } from "./VgtGlobalSearch.vue?vue&type=template&id=9228d57a&"
import script from "./VgtGlobalSearch.vue?vue&type=script&lang=js&"
export * from "./VgtGlobalSearch.vue?vue&type=script&lang=js&"
import style0 from "./VgtGlobalSearch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports